import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '../setup'

const selectCartSimulation = (state: AppState) => state.cartSimulation

// TODO: move to ../hooks
export const useCartSimulation = () => {
  const cartSimulation = useSelector(selectCartSimulation)

  return useMemo(
    () => ({
      cartSimulation,
    }),
    [cartSimulation]
  )
}
